export const sharedEffectElementTags = [
  'ai-error-wrapper',
  'ai-slides-renderer',
  'ai-answer-wrapper',
  'chat-content-images',
  'chat-content-pure-text',
  'chat-content-rich-text',
  'chat-content-stream-objects',
  'text-renderer',
  'tool-call-card',
  'tool-result-card',
  'tool-call-failed',
  'doc-semantic-search-result',
  'doc-keyword-search-result',
  'doc-read-result',
  'doc-write-tool',
  'web-crawl-tool',
  'web-search-tool',
  'section-edit-tool',
  'doc-compose-tool',
  'code-artifact-tool',
  'code-highlighter',
  'artifact-preview-panel',
  'doc-edit-tool',
  'artifact-skeleton',
] as const;

export type SharedEffectElementTag = (typeof sharedEffectElementTags)[number];

export const editorEffectElementTags = [
  'ask-ai-icon',
  'ask-ai-button',
  'ask-ai-toolbar-button',
  'ask-ai-panel',
  'affine-edgeless-ai-chat',
  'affine-ai-chat',
  'ai-chat-block-message',
  'ai-chat-block-messages',
  'ai-scrollable-text-renderer',
  'image-placeholder',
  'chat-image',
  'chat-images',
  'user-info',
  'generating-placeholder',
  'ai-finish-tip',
  'ai-panel-divider',
  'ai-panel-answer',
  'ai-panel-input',
  'ai-panel-generating',
  'ai-panel-error',
  'ai-block-diff-options',
  'affine-block-diff-playground',
  'affine-block-diff-playground-modal',
  'affine-ai-panel-widget',
  'affine-edgeless-copilot-widget',
  'affine-block-diff-widget-for-block',
  'affine-block-diff-widget-for-page',
  'edgeless-copilot-panel',
  'edgeless-copilot-toolbar-entry',
  'transcription-block',
] as const;

export type EditorEffectElementTag = (typeof editorEffectElementTags)[number];

export const appEffectElementTags = [
  'chat-action-list',
  'chat-copy-more',
  'image-preview-grid',
  'action-wrapper',
  'action-image-to-text',
  'action-image',
  'action-make-real',
  'action-mindmap',
  'action-slides',
  'action-text',
  'ai-loading',
  'ai-chat-content',
  'ai-chat-tabs',
  'ai-chat-toolbar',
  'ai-session-history',
  'ai-chat-messages',
  'ai-chat-input',
  'ai-chat-add-context',
  'ai-chat-embedding-status-tooltip',
  'ai-chat-composer',
  'chat-panel-chips',
  'ai-history-clear',
  'chat-panel-add-popover',
  'chat-input-preference',
  'chat-panel-candidates-popover',
  'chat-panel-doc-chip',
  'chat-panel-file-chip',
  'chat-panel-tag-chip',
  'chat-panel-collection-chip',
  'chat-panel-selected-chip',
  'chat-panel-attachment-chip',
  'chat-panel-chip',
  'chat-assistant-avatar',
  'chat-message-action',
  'chat-message-assistant',
  'chat-message-user',
  'ai-chat-block-peek-view',
  'date-time',
  'chat-panel-split-view',
] as const;

export type AppEffectElementTag = (typeof appEffectElementTags)[number];
